export default __webpack_public_path__ + "static/video-1-c6ae3ab41a6324a679fdd1643fb35f74.png";